import logo from './logo.svg';
import './index.css';
import Website from './components/Website';

function App() {
  return <Website />;
}

export default App;
